/* eslint-disable no-new */
export default {
    selectBankOperation({ commit }, item) {
        new Promise(resolve => {
            commit('SET_BANKOPERATION_SELECTED', item);
            resolve();
        });
    },
    removeBankOperation({ commit }, item) {
        new Promise(resolve => {
            commit('REMOVE_BANKOPERATION', item);
            resolve();
        });
    },
    removeRDOperation({ commit }, item) {
        new Promise(resolve => {
            commit('REMOVE_RDOPERATION', item);
            resolve();
        });
    },
    removeBankOperationsSelected({ commit }) {
        new Promise(resolve => {
            commit('REMOVE_BANKOPERATIONS_SELECTED');
            resolve();
        });
    },
    selectRDOperation({ commit }, item) {
        new Promise(resolve => {
            commit('SET_RDOPERATION_SELECTED', item);
            resolve();
        });
    },
    removeRDOperationsSelected({ commit }) {
        new Promise(resolve => {
            commit('REMOVE_RDOPERATIONS_SELECTED');
            resolve();
        });
    },
    setGroupedSelected({ commit }, value) {
        new Promise(resolve => {
            commit('SET_GROUPED_SELECTED', value);
            resolve();
        });
    },
    setUuidGroupedSelected({ commit }, value) {
        new Promise(resolve => {
            commit('SET_UUID_GROUPED_SELECTED', value);
            resolve();
        });
    },
    disableGroups({ commit }, value) {
        new Promise(resolve => {
            commit('SET_DISABLE_GROUPS', value);
            resolve();
        });
    },
    setComment({ commit }, value) {
        new Promise(resolve => {
            commit('SET_COMMENT', value);
            resolve();
        });
    },
    disableAll({ commit }, value) {
        new Promise(resolve => {
            commit('SET_DISABLEALL', value);
            resolve();
        });
    }
};
